import * as Yup from "yup";

const propertyFeatureSchema = Yup.object().shape({
  labelEn: Yup.string().required("Label En is required."),
  labelAr: Yup.string().required("Label Ar is required."),
  icon: Yup.string().required("Icon is required."),
  propertyCategoryIds: Yup.array()
    .min(1, 'Atleast one Property Category is required.')
    .required('Property Category is required.'),
  position: Yup.number()
    .min(0, "Please enter more than 0")
    .typeError("Must be Number"),
});

export default propertyFeatureSchema;
